import ApiBase from '../../../ApiBase';

class Field extends ApiBase {
    route = '/admin/cms/elements/fields';

    /**
     * @method indexAvailableFieldTypes
     * @return {Promise<*>}
     */
    indexAvailableFieldTypes = () => {
        return this.get(this.route + '/index-available-field-types');
    };
}

export default new Field();
